// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"wm-z","badgeLink":"xm-z","category":"ym-z"};